(function () {
    'use strict';

    angular.module("imApp").factory("propertyClassesService", [function () {
        let service = {};

        return service;
    }]);
})();
